import _styled from "@emotion/styled/base";
import { css } from '@emotion/react';
import { getResetByTag, typography, rem, rgba, colors } from '../../../styles';
import StyledAutoCompleteDropdownInner from './autocomplete.dropdown-inner.styles';
var defaultStyles = function defaultStyles(_ref) {
  var noRecordFound = _ref.noRecordFound;
  return /*#__PURE__*/css("border-left:solid ", rem(4), " ", colors.transparent, ";border-right:solid ", rem(4), " ", colors.transparent, ";cursor:", noRecordFound ? 'unset' : 'pointer', ";font-size:", typography.typographyBodySm, ";font-weight:", typography.typographyFontWeightBold, ";padding:", rem(0, 0, 0, 12), ";text-align:left;&:last-child{", StyledAutoCompleteDropdownInner, "{border-bottom:none;}}&:active{background-color:", noRecordFound ? 'unset' : colors.lightBlue_100, ";box-shadow:", noRecordFound ? "unset" : "inset ".concat(rem(0, 4, 4, 0), " ").concat(rgba(colors.blackDeep, 0.2)), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
};
var keydownEventStyles = function keydownEventStyles(_ref2) {
  var highlightedIndex = _ref2.highlightedIndex,
    index = _ref2.index,
    type = _ref2.type;
  if (highlightedIndex === index && type === 'mouseenter') {
    return /*#__PURE__*/css("background-color:", colors.lightBlue_100, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:keydownEventStyles;"));
  }
  if (highlightedIndex === index && type === 'keydown') {
    return /*#__PURE__*/css("border-left-color:", colors.lightBlue_500, ";border-right-color:", colors.lightBlue_500, ";box-shadow:", rem(0, 0, 0, 4), " ", colors.lightBlue_500, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:keydownEventStyles;"));
  } else {
    return /*#__PURE__*/css("box-shadow:", rem(0, 0, 0, 0), " ", colors.transparent, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:keydownEventStyles;"));
  }
};
var resetStyles = getResetByTag('li');
var StyledAutoCompleteListItem = /*#__PURE__*/_styled('li', process.env.NODE_ENV === "production" ? {
  target: "enzgdsv0"
} : {
  target: "enzgdsv0",
  label: "StyledAutoCompleteListItem"
})(resetStyles, defaultStyles, keydownEventStyles);
export default StyledAutoCompleteListItem;